import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('CreditNoteService', CreditNoteService);

  CreditNoteService.$inject = [
    'RestResource',
    '$translate',
    '$filter',
    'UtilService',
    'SessionService',
    'CreditNoteModalService',
    'ModalWindowConfirmService',
    'WindowModalService',
    'FileSaver',
  ];

  function CreditNoteService(
    RestResource,
    $translate,
    $filter,
    UtilService,
    SessionService,
    CreditNoteModalService,
    ModalWindowConfirmService,
    WindowModalService,
    FileSaver
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'credit_notes';

    var service = {
      getFilterCriteria: getFilterCriteria,
      getCreditNotes: getCreditNotes,
      getCreditNote: getCreditNote,
      saveCreditNote: saveCreditNote,
      deleteCreditNote: deleteCreditNote,
      removeCreditNoteItems: removeCreditNoteItems,
      openSendCreditNoteToClient: openSendCreditNoteToClient,
      downloadCreditNotePdf: downloadCreditNotePdf,
      openRelatedTransactions: openRelatedTransactions,
      getRelatedTransactions: getRelatedTransactions,
    };

    return service;

    ////////////////

    function getFilterCriteria() {
      var filter = {
        page: 1,
        sortDir: 'desc',
        sortedBy: 'date',
      };

      return filter;
    }

    function getCreditNotes(filterCriteria) {
      if (!filterCriteria) {
        filterCriteria = getFilterCriteria();
      }

      filterCriteria.company_id = SessionService.getSelectedAccountCompany().id;

      return RestResource.request(
        'get',
        apiUrl,
        filterCriteria,
        function (response) {
          response = response.data;

          if (response.meta) {
            return {
              items: response.data,
              meta: utils.getItemsMetaData(response, filterCriteria),
            };
          } else {
            return {
              items: response,
            };
          }
        },
        {}
      );
    }

    function getCreditNote(id) {
      return RestResource.request(
        'get',
        apiUrl + '/' + id,
        {},
        function (response) {
          return response.data;
        },
        function () {
          // console.log(response.data.error);
          return false;
        }
      );
    }

    function saveCreditNote(creditNote) {
      // webhookEndPoint
      let method = 'post';
      let url = apiUrl;

      // let webhookUrl = ENV.apiEndpoint + webhookEndPoint;

      if (creditNote.id) {
        // edit
        method = 'put';
        url = apiUrl + '/' + creditNote.id;
      }

      function success(response) {
        let msg =
          creditNote.status === 'draft' ? 'CREDIT_NOTE_SAVED_AS_DRAFT' : 'CREDIT_NOTE_CREATED';
        utils._successMsg($translate(msg));

        return {
          status: true,
          response: response.data,
        };
      }

      function failure(response) {
        return {
          status: false,
          response: response.data,
        };
      }

      return RestResource.request(method, url, { credit_note: creditNote }, success, failure); // , webhookUrl: webhookUrl
    }

    // Only for draft items
    function deleteCreditNote(creditNote, successCallback) {
      let url = apiUrl + '/' + creditNote.id;

      return RestResource.request(
        'delete',
        url + '?check_if_used=true',
        { company_id: creditNote.company_id },
        function () {
          let params = {
            title: 'DELETE_CREDIT_NOTE',
            reason: 'DELETE_ITEM_REASON',
            successMsg: 'CREDIT_NOTE_DELETED',
            company_id: creditNote.company_id,
          };

          utils.deleteItem(url, successCallback, params);
        },
        function (response) {
          utils.openModalError(response.data.error);
        }
      );
    }

    function removeCreditNoteItems(successCallback, cancelCallback) {
      var modalParams = {
        mode: 'danger',
        title: 'CHANGE_CLIENT_FOR_CURRENT_CREDIT_NOTE',
        body: 'CHANGE_CLIENT_FOR_CURRENT_CREDIT_NOTE_WARNING',
      };

      var confirmCallback = function () {
        return successCallback();
      };

      ModalWindowConfirmService.open(modalParams, confirmCallback, cancelCallback);
    }

    function openSendCreditNoteToClient(clientEmail, successCallback) {
      CreditNoteModalService.openSendCreditNoteToClient(clientEmail, successCallback);
    }

    function downloadCreditNotePdf(creditNote, lang) {
      var apiUrlPdf = apiUrl + '/' + creditNote.id + '/credit_note_pdf.pdf';

      return RestResource.request(
        'get',
        apiUrlPdf,
        { company_id: creditNote.company_id, lang: lang },
        function (response) {
          let blobVar = new Blob([response.data], { type: 'application/pdf' });

          FileSaver.saveAs(
            blobVar,
            $translate('CREDIT_NOTECE') + ' ' + creditNote.credit_note_number + '.pdf'
          );
        },
        function () {}
      );
    }

    function openRelatedTransactions(transaction, client) {
      let templateUrl = './app/ajs/credit-notes/modals/credit-note-related-transactions-modal.html';

      let modalParams = {
        item: transaction,
        additionalParams: {
          clientId: client.id,
        },
      };

      WindowModalService.open(templateUrl, modalParams);
    }

    function getRelatedTransactions(id, clientId) {
      const params = {
        skip_check_role: true,
        client_id: clientId,
      };

      return RestResource.request(
        'get',
        apiUrl + '/' + id + '/related_transaction/',
        params,
        function (response) {
          return response.data;
        },
        function (err) {
          return err;
        }
      );
    }
  }
})();
